import React, { useEffect, useState } from 'react';
import styles from '@/styles/FriendshipLink.module.css';
import { getFriendlyLinks, type FriendlyLink } from '@/api/api';

export const FriendshipLink = () => {
    const [friendlyLinks, setFriendlyLinks] = useState<FriendlyLink[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchLinks = async () => {
            try {
                setLoading(true);
                const response = await getFriendlyLinks();
                if (response.data.code === 1) {
                    setFriendlyLinks(response.data.data);
                }
            } catch (error) {
                console.error('Error fetching friendly links:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchLinks();
    }, []);

    return (
        <>
            <div className={styles.friendshipLinkContainer}>
                <div className={styles.friendshipLinkHeaderBox}>
                    <div className={styles.friendshipLinkHeader}>
                        友情链接
                    </div>
                </div>
                <div className={styles.friendshipLinkBody}>
                    {loading ? (
                        <span>加载中...</span>
                    ) : friendlyLinks.length > 0 ? (
                        friendlyLinks.map((link) => (
                            <a key={link.id} href={link.url} target="_blank" rel="noopener noreferrer">
                                <span>{link.name}</span>
                            </a>
                        ))
                    ) : (
                        <>
                            <span>示例友情链接</span>
                        </>
                    )}
                </div>
            </div>
        </>
    );
};